"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRemoteSubmission = exports.mergeChangesIntoModel = void 0;
const ndtrcModelHelper_1 = require("./ndtrcModelHelper");
const feed_factory_helpers_1 = require("@feed-factory/feed-factory.helpers");
const mergeChangesIntoModel = (mainDataObject, changes) => {
    if (!changes) {
        return mainDataObject;
    }
    return Object.assign(Object.assign(Object.assign({}, mainDataObject), changes), { trcItemDetails: Object.assign(Object.assign({}, mainDataObject.trcItemDetails), changes.trcItemDetails), trcItemCategories: Object.assign(Object.assign({}, mainDataObject.trcItemCategories), changes.trcItemCategories), calendar: Object.assign(Object.assign({}, mainDataObject.calendar), changes.calendar) });
};
exports.mergeChangesIntoModel = mergeChangesIntoModel;
const handleRemoteSubmission = (originalItem, changedItem, itemId) => {
    if (!originalItem) {
        throw new Error("No originalItem provided");
    }
    const transformedChangedData = (0, ndtrcModelHelper_1.internalToExternal)(changedItem);
    // Merge original location with changed location to retain ID object
    // TODO: Remove; is temporary, until locations fully supported
    const locationMerged = {
        location: Object.assign(Object.assign({}, originalItem.location), transformedChangedData.location),
    };
    const isNewItem = !originalItem.id;
    // Determine url based on item type
    let url;
    if (originalItem.entitytype === "EVENEMENT") {
        url = `/events`;
    }
    else if (originalItem.entitytype === "LOCATIE") {
        url = `/locations`;
    }
    else {
        throw new Error("Item type unknown");
    }
    if (!isNewItem) {
        url += `/${itemId}`;
    }
    const payload = Object.assign(Object.assign(Object.assign({}, originalItem), transformedChangedData), locationMerged);
    console.log("PUT ITEM (PAYLOAD):", payload); // DEBUG
    // Merge original item with changes
    // Required until form entirely describes the object
    if (isNewItem) {
        return feed_factory_helpers_1.feedFactoryAxios.post(url, payload);
    }
    else {
        return feed_factory_helpers_1.feedFactoryAxios.put(url, payload);
    }
};
exports.handleRemoteSubmission = handleRemoteSubmission;
//# sourceMappingURL=itemFormSharedLogic.js.map